import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.workspace');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-workspace',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.workspace/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.workspace-page {
  width: 100%;
  max-width: 860px;
  margin: 0 auto;
}

.workspace-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 32px;
  gap: 24px;
}

.workspace-heading h2 {
  margin: 0;
  color: var(--kiom-ink);
  font-size: clamp(30px, 3vw, 36px);
  line-height: 1.2;
  letter-spacing: -0.035em;
}

.workspace-heading p {
  margin: 11px 0 0;
  color: #536761;
  font-size: 15px;
  line-height: 1.6;
}

.workspace-heading p strong {
  color: #2c4841;
  font-weight: 750;
}

.logout-button {
  min-width: 84px;
  min-height: 42px;
  padding: 0 15px;
  border: 1px solid #cbd8d4;
  border-radius: 10px;
  color: #3f5d55;
  background: #fff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  transition: border-color 0.18s, color 0.18s, background 0.18s;
}

.logout-button:hover {
  border-color: #92ada5;
  color: var(--kiom-primary);
  background: #f5faf8;
}

.portal-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.portal-card {
  position: relative;
  min-height: 280px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  padding: 28px;
  border: 1px solid #d3dedb;
  border-radius: 18px;
  color: var(--kiom-ink);
  background: white;
  font-family: inherit;
  text-align: left;
  transition: transform 0.18s, border-color 0.18s, box-shadow 0.18s;
}

.portal-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 38px rgba(28, 57, 50, 0.1);
}

.authoring-card:hover {
  border-color: #98c3b7;
}

.review-card:hover {
  border-color: #a9add2;
}

.portal-card:focus-visible,
.logout-button:focus-visible {
  outline: 3px solid rgba(23, 111, 91, 0.22);
  outline-offset: 3px;
}

.portal-icon {
  display: grid;
  width: 56px;
  height: 56px;
  margin-bottom: 24px;
  place-items: center;
  border-radius: 16px;
}

.authoring-card .portal-icon {
  color: #1f6b59;
  background: #e6f3ef;
}

.review-card .portal-icon {
  color: #454d8c;
  background: #ececf6;
}

.portal-icon svg {
  width: 28px;
  height: 28px;
  fill: currentColor;
}

.portal-copy > strong,
.portal-copy > span {
  display: block;
}

.portal-copy > strong {
  font-size: 22px;
  line-height: 1.3;
  letter-spacing: -0.025em;
}

.portal-copy > span {
  margin-top: 10px;
  color: #576c66;
  font-size: 14px;
  line-height: 1.65;
  word-break: keep-all;
}

.portal-action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 26px;
  color: #345f55;
  font-size: 14px;
  font-weight: 750;
  gap: 6px;
}

.review-card .portal-action {
  color: #454d8c;
}

.portal-action svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
  transition: transform 0.18s;
}

.portal-card:hover .portal-action svg {
  transform: translateX(3px);
}

.entry-rule {
  padding: 28px;
  border: 1px solid #d7e1de;
  border-radius: 16px;
  color: #5d716b;
  background: #f5f8f7;
  font-size: 14px;
  line-height: 1.6;
  text-align: center;
}

.entry-rule strong {
  display: block;
  margin-bottom: 5px;
  color: #42554f;
  font-size: 17px;
}

@media (max-width: 700px) {
  .portal-grid {
    grid-template-columns: 1fr;
  }
  .portal-card {
    min-height: 240px;
  }
}
@media (max-width: 520px) {
  .workspace-header {
    margin-bottom: 26px;
    gap: 16px;
  }
  .workspace-heading h2 {
    font-size: 30px;
  }
  .workspace-heading p {
    font-size: 14px;
  }
  .logout-button {
    min-width: 76px;
    min-height: 40px;
    padding: 0 12px;
    font-size: 13px;
  }
  .portal-card {
    min-height: 224px;
    padding: 22px;
  }
  .portal-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
  }
  .portal-copy > strong {
    font-size: 20px;
  }
}`],
})
export class PageWorkspaceComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (!this.service.auth.check()) {
            this.service.href('/access');
            return;
        }
        if (this.service.auth.session.account_status !== 'ACTIVE') {
            this.service.href('/status/pending');
        }
    }

    public allows(portal: string) {
        return (this.service.auth.session.portals || []).indexOf(portal) >= 0;
    }

    public openPortal(path: string) {
        this.service.href(path);
    }

    public async logout() {
        await this.service.request.post('/api/account/logout');
        location.href = '/access';
    }
}

export default PageWorkspaceComponent;